/** Correlation hints only: never evidence that a human personally clicked. */
let pageId: string | undefined;

export function generationAuditHeaders(action?: string): Record<string, string> {
  try {
    pageId ??= crypto.randomUUID();
    let clientId = localStorage.getItem('autoqm_audit_client_id');
    if (!clientId) {
      clientId = crypto.randomUUID();
      localStorage.setItem('autoqm_audit_client_id', clientId);
    }
    return {
      'X-AutoQM-Client-Id': clientId,
      'X-AutoQM-Page-Id': pageId,
      ...(action ? { 'X-Generation-Action': action } : {}),
    };
  } catch {
    // Disabled storage or missing crypto must never block a generation request.
    return {};
  }
}
